import React, {useEffect, useState, useRef} from 'react'
//import { getGraphs } from './Api';
import { getInventory, getInventoryCSV,setInventoryThreshold,setInventoryTarget, getInventoryHostKeys, setInventoryHostkeyTitle, setInventoryComment, getInventoryLogs, updateInventoryLogNote } from './Api';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, useNavigate } from "react-router-dom";

const Inventory = () => {
    const [csvs, setCSVs] = useState([]);
    const [hostkeys, setHostkeys] = useState([]);
    const [permission, setPermission] = useState(0);
    const [waitUpdate, setWaitUpdate] = useState(null);
    const [inventoryAssets, setInventoryAssets] = useState([]);
    const [editField, setEditField] = useState(null);
    const [commentModalOpen, setCommentModalOpen] = useState(false);
    const [commentModalSaving, setCommentModalSaving] = useState(false);
    const [commentEditHostkey, setCommentEditHostkey] = useState("1");
    const [commentEditBarcode, setCommentEditBarcode] = useState("");
    const [commentEditTitle, setCommentEditTitle] = useState("");
    const [commentEditValue, setCommentEditValue] = useState("");
    const [logModalOpen, setLogModalOpen] = useState(false);
    const [logModalLoading, setLogModalLoading] = useState(false);
    const [logModalError, setLogModalError] = useState("");
    const [logModalTitle, setLogModalTitle] = useState("");
    const [logModalHostkey, setLogModalHostkey] = useState("1");
    const [logModalBarcode, setLogModalBarcode] = useState("");
    const [logModalEntries, setLogModalEntries] = useState([]);
    const [logTimeframe, setLogTimeframe] = useState('all');
    const [logEditEntryId, setLogEditEntryId] = useState(null);
    const [logEditValue, setLogEditValue] = useState('');
    const [logEditSaving, setLogEditSaving] = useState(false);

    const logTimeframeOptions = [
        { value: '24h', label: '24h' },
        { value: '7d', label: '7d' },
        { value: '30d', label: '30d' },
        { value: '6m', label: '6m' },
        { value: '1y', label: '1y' },
        { value: 'all', label: 'All' },
    ];

    useEffect( () => { 
        setInventoryAssets([]);
        setHostkeys([]);
        getInventoryHostKeys().then(async function(data) {
            console.log("Inventory hostkeys:", data.inventory_hosts);
            setHostkeys(data.inventory_hosts);

            for(let i in data.inventory_hosts){
                let hostkey = data.inventory_hosts[i];
                console.log("Loading inventory for hostkey ", hostkey.permission_key);
                await getInventory(hostkey.permission_key).then(function(inventoryData) {
                    setPermission(inventoryData.permission);
                    setInventoryAssets( (prevInventoryAssets) => { return [...prevInventoryAssets, {hostkey: hostkey.permission_key, title: data.inventory_hosts[i].title, inventory: inventoryData.inventory_assets } ] } );
                    //setInventoryAssets(data.inventory_assets);
                    console.log("Loaded inventory for hostkey ", hostkey.permission_key);
                });
            }
        });

        /*getInventory().then(function(data) {
          
          //setCSVs(data.csvs);
          //setInventoryAssets(data.inventory_assets)
          //setPermission(data.permission);
        });
        */
    
      }, []);

    const handleDownload = (evt) => {
        console.log(evt.nativeEvent.target );
        getInventoryCSV(evt.target.dataset.csv);
        
    }

    const handleUpdateThreshold = async(evt) => {
        console.log(evt.target.dataset.barcode, "=>", evt.target.value);
        // Don't save immediately!
        try{ clearTimeout(waitUpdate);}catch(e) {console.log(e); }
        evt.target.parentElement.querySelector(".save-inventory").style.display='block';
        
        setWaitUpdate(
            setTimeout(()=>{
                setInventoryThreshold(evt.target.dataset.barcode, evt.target.value, evt.target.dataset.hostkey).then( () => {evt.target.parentElement.querySelector(".save-inventory").style.display='none';});
            }, 300)    
        );
        //evt.target.parentElement.querySelector("button").classList.add("active");
    };
        const handleUpdateTarget = async(evt) => {
        console.log(evt.target.dataset.barcode, "=>", evt.target.value);
        // Don't save immediately!
        try{ clearTimeout(waitUpdate);}catch(e) {console.log(e); }
        evt.target.parentElement.querySelector(".save-inventory").style.display='block';
        
        setWaitUpdate(
            setTimeout(()=>{
                setInventoryTarget(evt.target.dataset.barcode, evt.target.value, evt.target.dataset.hostkey).then( () => {evt.target.parentElement.querySelector(".save-inventory").style.display='none';});
            }, 300)    
        );
        //evt.target.parentElement.querySelector("button").classList.add("active");
    };

    const handleEditName = async(evt) => {
        console.log(evt.target);
        setEditField(evt.target.dataset.hostkey);
    };

    const handleSaveNameField = async(evt) => {
        console.log(evt.target);

        console.log(evt.target.parentElement.querySelector(".save-inventory"));
        let parent = evt.target.parentElement;
        let hostkey = evt.target.dataset.hostkey;
        let save_inventory_spinner = evt.target.parentElement.querySelector(".save-inventory");
        evt.target.parentElement.querySelector(".save-inventory").style.display='inline-block';
        let value = ""+(evt.target.parentElement.querySelector(".edit-box").value);
        setInventoryHostkeyTitle(hostkey, value).then( (data) => {
            save_inventory_spinner.style.display='none';
            //parent.querySelector(".hostkeytitle").textContent = value;
            
            // replace the hostkey title in the inventoryAssets array
            let newInventoryAssets = [...inventoryAssets];
            for(let i in newInventoryAssets){
                if(newInventoryAssets[i].hostkey === hostkey){
                    newInventoryAssets[i].title = value;
                }
            }
            setInventoryAssets(newInventoryAssets);
            setEditField(null);
            
        }).catch( (e) => {
            setEditField(null);
            save_inventory_spinner.style.display='none';
        });
    }

    const handleEditComment = async(barcode, hostkey, currentComment, currentTitle) => {
        setCommentEditBarcode(barcode);
        setCommentEditHostkey(hostkey);
        setCommentEditValue(currentComment || "");
        setCommentEditTitle(currentTitle || "Asset");
        setCommentModalOpen(true);
    }

    const handleCloseCommentModal = () => {
        if(commentModalSaving) {
            return false;
        }
        setCommentModalOpen(false);
    }

    const formatUtcAsLocalTime = (utcValue) => {
        if (!utcValue) {
            return "-";
        }

        const raw = String(utcValue).trim();
        if (raw === "") {
            return "-";
        }

        const isoLike = raw.includes('T') ? raw : raw.replace(' ', 'T');
        const date = new Date(isoLike.endsWith('Z') ? isoLike : (isoLike + 'Z'));

        if (Number.isNaN(date.getTime())) {
            return "-";
        }

        return date.toLocaleString("sv-SE");
    }

    const handleOpenLogModal = async (barcode, hostkey, title) => {
        setLogModalOpen(true);
        setLogModalHostkey(hostkey || "1");
        setLogModalBarcode(barcode || "");
        setLogModalTitle(title || "Asset");
        setLogModalLoading(true);
        setLogModalError("");
        setLogModalEntries([]);
        setLogTimeframe('all');

        try {
            const logs = await getInventoryLogs(barcode, hostkey || "1");
            setLogModalEntries(logs);
        } catch (e) {
            setLogModalError("Could not load log history for this asset.");
        } finally {
            setLogModalLoading(false);
        }
    }

    const handleAssetLinkClick = (event, barcode, hostkey, title) => {
        const selectedText = (typeof window !== 'undefined' && window.getSelection) ? window.getSelection().toString() : "";
        if (selectedText && selectedText.trim().length > 0) {
            return;
        }
        handleOpenLogModal(barcode, hostkey, title);
    }

    const handleCloseLogModal = () => {
        setLogModalOpen(false);
        setLogModalLoading(false);
        setLogModalError("");
        setLogModalEntries([]);
        setLogEditEntryId(null);
        setLogEditValue("");
        setLogEditSaving(false);
    }

    const handleStartLogEdit = (entry) => {
        if (permission < 3) {
            return;
        }
        setLogEditEntryId(entry && entry.id ? entry.id : null);
        setLogEditValue(entry && entry.note ? String(entry.note) : "");
    }

    const handleSaveLogEdit = async () => {
        if (!logEditEntryId || permission < 3) {
            return;
        }

        setLogEditSaving(true);

        try {
            const updated = await updateInventoryLogNote(logEditEntryId, logModalBarcode, logModalHostkey, logEditValue);
            const nextEntries = logModalEntries.map((entry) => (
                entry && entry.id === logEditEntryId ? { ...entry, note: updated && updated.note !== undefined ? updated.note : logEditValue } : entry
            ));
            setLogModalEntries(nextEntries);
            setLogEditEntryId(null);
            setLogEditValue("");
        } catch (e) {
            alert("Could not update the log note.");
        } finally {
            setLogEditSaving(false);
        }
    }

    const summarizeLogNotes = (entries) => {
        const summary = {};
        entries.forEach((entry) => {
            const note = (entry && entry.note !== null && typeof entry.note !== 'undefined' && String(entry.note).trim() !== '') ? String(entry.note).trim() : '(no note)';
            summary[note] = (summary[note] || 0) + 1;
        });
        return Object.entries(summary).sort((a, b) => b[1] - a[1]);
    }

    const filterLogEntriesByTimeframe = (entries, timeframe) => {
        if (!Array.isArray(entries) || !entries.length) {
            return [];
        }

        const now = Date.now();
        const limits = {
            '24h': 1000 * 60 * 60 * 24,
            '7d': 1000 * 60 * 60 * 24 * 7,
            '30d': 1000 * 60 * 60 * 24 * 30,
            '6m': 1000 * 60 * 60 * 24 * 30 * 6,
            '1y': 1000 * 60 * 60 * 24 * 365,
            'all': null,
        };

        const cutoff = limits[timeframe];
        if (!cutoff) {
            return [...entries].sort((a, b) => new Date(b.event_timestamp_utc) - new Date(a.event_timestamp_utc));
        }

        return entries.filter((entry) => {
            const value = new Date(entry.event_timestamp_utc).getTime();
            if (Number.isNaN(value)) {
                return false;
            }
            return (now - value) <= cutoff;
        }).sort((a, b) => new Date(b.event_timestamp_utc) - new Date(a.event_timestamp_utc));
    }

    const handleSaveCommentModal = async () => {
        setCommentModalSaving(true);
        setInventoryComment(commentEditBarcode, commentEditValue, commentEditHostkey).then( () => {
            let newInventoryAssets = [...inventoryAssets];
            for(let i in newInventoryAssets){
                if(newInventoryAssets[i].hostkey === commentEditHostkey){
                    for(let j in newInventoryAssets[i].inventory){
                        if(newInventoryAssets[i].inventory[j].barcode === commentEditBarcode){
                            newInventoryAssets[i].inventory[j].comment = commentEditValue;
                        }
                    }
                }
            }
            setInventoryAssets(newInventoryAssets);
            setCommentModalOpen(false);
            setCommentModalSaving(false);
        }).catch( () => {
            setCommentModalSaving(false);
            alert("Could not save comment");
        });
    }

    const logHostTitle = inventoryAssets.find((group) => group.hostkey === logModalHostkey)?.title || logModalHostkey;
    const visibleLogEntries = filterLogEntriesByTimeframe(logModalEntries, logTimeframe);
    const visibleLogSummary = summarizeLogNotes(visibleLogEntries);

    return (<>
        <div className="top-bar">
        Service: Inventory
        </div>

        
        <div className="service">

            <div className="section inventory">
            <div className="title">Inventory</div>
            <div className="information">The Inventory Assets table below is updated once every hour if the Raspberry PI has connection to the internet.
            <br/>Admins can set threshold, if the amount goes below the given threshold, an alert mail will be sent to your specified contact at 12:45.</div>
            <br/>
            <hr/>
            <br/>
            <div className=""><div>
            {/* <div className="information">Last received update: { inventoryAssets.length > 0 ? (new Date(inventoryAssets[0].last_update_time*1000).toLocaleString("sv-SE")) : "" }</div> */}
            <br/>
            <div className="inventory-flex">
                {inventoryAssets.length > 0 ? (<></>) : (<> <span className="save-inventory relative show gray"><FontAwesomeIcon icon="fa-solid fa-spinner" /></span></>)}
            { inventoryAssets.map( (hostkey, index) => {
            return (<div className="inventory-asset-box"  key={"hostkey_asset_box_"+index} >
            <div className="inventory-title" key={"hostkey_title_"+index}>
                { editField === hostkey.hostkey ? (<><input type='text' className='edit-box' defaultValue={hostkey.title} />
                <a className="inventory-comment edit-key green" data-hostkey={hostkey.hostkey} onClick={handleSaveNameField}><FontAwesomeIcon icon="fa-solid fa-floppy-disk" /></a></>) : (<><span className="hostkeytitle">{hostkey.title}</span> { permission === 3 ? (
                <a className="inventory-comment edit-key" onClick={handleEditName} data-hostkey={hostkey.hostkey}><FontAwesomeIcon icon="fa-solid fa-pen-to-square" /></a>
                ) : (<></>) }</>)} <div className="save-inventory relative"><FontAwesomeIcon icon="fa-solid fa-spinner" /></div>
                <div className="inventory-comment" key={"hostkey_comment_"+index}>ID: {hostkey.hostkey}</div>
                <div className="inventory-comment small italic">Last update:
                    { ( (new Date()).getTime()- (7 * 24 * 3600 * 1000) > hostkey.inventory[0].last_update_time*1000) ? 
                     (<span className="warn bold text-red"><FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" /> {new Date(hostkey.inventory[0].last_update_time*1000).toLocaleString("sv-SE")}</span>) : 
                     (new Date(hostkey.inventory[0].last_update_time*1000).toLocaleString("sv-SE"))}</div>
                </div>

            <table className="inventory" key={"hostkey_table_"+index}>
                <tbody>
                <tr>
                <td><FontAwesomeIcon icon="fa-solid fa-comment" /></td><td>Asset</td><td>Amount</td><td>Alert</td><td></td><td>Target</td><td>Missing</td>
                </tr>
                { typeof hostkey.inventory.length != "undefined" ? ( hostkey.inventory.map( (inventoryAsset,index) => {return (
                <tr key={"inventoryAsset_id_"+index} ><td><a className={"inventory-asset-comment-icon " + (((inventoryAsset.comment || "").trim().length > 0) ? "set" : "unset")} title={(inventoryAsset.comment || "").trim().length > 0 ? inventoryAsset.comment : "No comment set"} onClick={() => { handleEditComment(inventoryAsset.barcode, inventoryAsset.hostkey, inventoryAsset.comment, inventoryAsset.title); }}><FontAwesomeIcon icon={((inventoryAsset.comment || "").trim().length > 0) ? "fa-solid fa-comment" : "fa-regular fa-comment"} /></a></td><td><button type="button" className="inventory-asset-log-link" onClick={(event) => { handleAssetLinkClick(event, inventoryAsset.barcode, inventoryAsset.hostkey, inventoryAsset.title); }}>{inventoryAsset.title}</button></td><td className={ inventoryAsset.amount < inventoryAsset.threshold ? "warn" : "" }>{inventoryAsset.amount}</td>
                <td className="threshold-td"> { permission === 3 ? ( <><input className="threshold" onChange={handleUpdateThreshold} data-barcode={inventoryAsset.barcode} data-hostkey={inventoryAsset.hostkey} type="number" defaultValue={inventoryAsset.threshold} /> <div className="save-inventory"><FontAwesomeIcon icon="fa-solid fa-spinner" /></div></> ) : (<>{inventoryAsset.threshold}</>) } </td><td className="warn">{ inventoryAsset.amount < inventoryAsset.threshold ? (<><FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" /></>) : (<></>) }</td>
                <td className="threshold-td">
                { permission === 3 ? ( <><input className="target" onChange={handleUpdateTarget} data-barcode={inventoryAsset.barcode} data-hostkey={inventoryAsset.hostkey} type="number" defaultValue={inventoryAsset.target} /> <div className="save-inventory"><FontAwesomeIcon icon="fa-solid fa-spinner" /></div></> ) : (<>{inventoryAsset.target}</>) }     
                </td><td>{ (Number(inventoryAsset.target || 0) > 0 && Number(inventoryAsset.amount) < Number(inventoryAsset.target || 0)) ? <span className="warn">{(Number(inventoryAsset.target || 0) - Number(inventoryAsset.amount))}</span> : <><FontAwesomeIcon className="check-green" icon="fa-solid fa-square-check" /></> }</td></tr>
                )}) ) : (<>Loading...</>) }
                </tbody>
            </table>

            </div>)
            } ) }


            
            </div>
            
            </div></div>
            </div>
        </div>

        {commentModalOpen ? (
        <div className="inventory-comment-modal-overlay" onClick={handleCloseCommentModal}>
            <div className="inventory-comment-modal" onClick={(evt) => { evt.stopPropagation(); }}>
                <div className="title">Comment</div>
                <div className="information">{commentEditTitle}</div>
                <textarea className="inventory-comment-modal-textarea" value={commentEditValue} onChange={(evt) => { setCommentEditValue(evt.target.value); }} />
                <div className="inventory-comment-modal-actions">
                    <button className="btn secondary" onClick={handleCloseCommentModal}>Cancel</button>
                    <button className="btn" onClick={handleSaveCommentModal} disabled={commentModalSaving}>{commentModalSaving ? "Saving..." : "Save"}</button>
                </div>
            </div>
        </div>
        ) : (<></>)}

        {logModalOpen ? (
        <div className="inventory-comment-modal-overlay" onClick={handleCloseLogModal}>
            <div className="inventory-log-modal" onClick={(evt) => { evt.stopPropagation(); }}>
                <div className="title">Asset log history</div>
                <div className="information">{logModalTitle} · {logHostTitle} ({logModalHostkey})</div>
                {logModalLoading ? (
                    <div className="inventory-log-modal-loading"><FontAwesomeIcon icon="fa-solid fa-spinner" /> Loading log entries...</div>
                ) : logModalError ? (
                    <div className="inventory-log-modal-error">{logModalError}</div>
                ) : (
                    <>
                        <div className="inventory-log-range-picker">
                            {logTimeframeOptions.map((option) => (
                                <button
                                    key={option.value}
                                    type="button"
                                    className={logTimeframe === option.value ? 'active' : ''}
                                    onClick={() => setLogTimeframe(option.value)}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                        <div className="inventory-log-summary">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Note Statistics</th>
                                        <th>Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {visibleLogSummary.length === 0 ? (
                                        <tr><td colSpan="2">No notes</td></tr>
                                    ) : (
                                        visibleLogSummary.map(([label, count], idx) => (
                                            <tr key={"log-summary-" + idx}>
                                                <td>{label}</td>
                                                <td>{count}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="inventory-log-modal-table-wrap">
                            <table className="inventory-log-modal-table">
                                <thead>
                                    <tr>
                                        <th>Time</th>
                                        <th>Amount</th>
                                        <th>Note</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {visibleLogEntries.length === 0 ? (
                                        <tr><td colSpan="3">No entries in this time range.</td></tr>
                                    ) : (
                                        visibleLogEntries.map((entry, idx) => (
                                            <tr key={"log-row-"+idx}>
                                                <td>{formatUtcAsLocalTime(entry.event_timestamp_utc)}</td>
                                                <td className={entry.amount >= 0 ? "amount-positive" : "amount-negative"}>{entry.amount >= 0 ? '+' : ''}{entry.amount}</td>
                                                {permission >= 3 ? (
                                                    <td className="inventory-log-note-cell">
                                                        {logEditEntryId === entry.id ? (
                                                            <>
                                                                <div className="inventory-log-note-edit-wrap">
                                                                    <textarea
                                                                        value={logEditValue}
                                                                        onChange={(evt) => setLogEditValue(evt.target.value)}
                                                                        rows={3}
                                                                        className="inventory-log-inline-edit"
                                                                    />
                                                                    <div className="inventory-log-inline-actions">
                                                                        <button className="btn secondary small" type="button" onClick={() => { setLogEditEntryId(null); setLogEditValue(""); }} disabled={logEditSaving}>Cancel</button>
                                                                        <button className="btn small" type="button" onClick={handleSaveLogEdit} disabled={logEditSaving}>{logEditSaving ? 'Saving...' : 'Save'}</button>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span className="inventory-log-note-text">{entry.note || "(no note)"}</span>
                                                                <button
                                                                    type="button"
                                                                    className="inventory-log-note-edit-btn"
                                                                    onClick={() => handleStartLogEdit(entry)}
                                                                    title="Edit note"
                                                                    aria-label="Edit note"
                                                                >
                                                                    <FontAwesomeIcon icon="fa-solid fa-pen" />
                                                                </button>
                                                            </>
                                                        )}
                                                    </td>
                                                ) : (
                                                    <td className="inventory-log-note-cell"><span className="inventory-log-note-text">{entry.note || "(no note)"}</span></td>
                                                )}
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                <div className="inventory-comment-modal-actions">
                    <button className="btn secondary" onClick={handleCloseLogModal}>Close</button>
                </div>
            </div>
        </div>
        ) : (<></>)}
        </>);
}
export default Inventory
